<style lang="less" scoped>
@small-page-width: 1140px;
@middle-page-width: 1720px;
@large-page-width: 100%;
.header {
  background: #fff;
  &.hasOpacity {
    opacity: 0.8;
  }
  height: 4.4rem;
  line-height: 4.4rem;
  padding: 0 40px;
  .header-c {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 35rem;
    .logo {
      img {
        vertical-align: middle;
        height: 46px;
      }
    }
  }
  .small {
    width: @small-page-width;
  }
  .middle {
    width: @middle-page-width;
  }
  .large {
    width: @large-page-width;
  }
}
</style>

<template>
  <Header class="header">
    <div :class="headerClass">
      <div class="logo">
        <slot name="header-left"/>
      </div>
      <div class="main-opts">
        <slot name="header-right"/>
      </div>
    </div>
  </Header>
</template>

<script>
import { OneOf } from '@/lib/common'
export default {
  name: 'cisHeader',
  props: {
    size: {
      type: String,
      validator(val) {
        return OneOf(val, ['normal', 'small', 'large', 'middle'])
      },
      default: 'normal'
    },
    opacity: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headerClass() {
      return `${this.size} ${this.opacity ? 'hasOpacity' : ''} header-c`
    }
  }
}
</script>
